<template>
  <div>
    <v-layout style="background-color: #fff; color: #000;" wrap justify-center align-center>
      <v-layout wrap align-center style="padding:5px 5px 0px 10px">
        <v-flex grow>
          <span class="headline">Notificações</span>
        </v-flex>
        <v-flex shrink text-sm-right>
          <v-layout wrap align-center>
            <v-tooltip bottom>
              <v-checkbox light align-end color="primary" slot="activator" v-model="filterItemMention" @change="filterMention" label="Apenas menções"></v-checkbox>
              <span>Filtre apenas quem te mencionou</span>
            </v-tooltip>
            <v-tooltip bottom v-if="checkNotificationSupported">
              <v-btn align-end round :loading="notificationLoading" :color="notificationsEnabled ? 'success' : '#888888'" @click="enableNotifications" slot="activator"> 
                <v-icon left>{{notificationsEnabled ? 'notifications_active' : 'notifications_off'}}</v-icon> pop-up's
              </v-btn>
              <span>{{notificationsEnabled ? 'Desativar' : 'Ativar'}}pop-up's</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn light align-end round class="mx-0" color="primary" @click="clearAll(items)" slot="activator" :loading="clearAllLoading" :disabled="items.length === 0">Limpar tudo</v-btn>
              <span>Limpar todas as notificações</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
        <v-flex shrink text-sm-right>
          <v-tooltip bottom>
            <v-btn flat icon align-end color="#000" @click="$emit('closeNotifications')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <div :style="(!$vuetify.breakpoint.smAndDown?'max-height: 550px;':'max-height: 300px;')+'overflow-y: auto; width: 100%;'">
        <v-flex xs12>
          <v-progress-linear :style="'width: 50vw;'" v-if="notificationLoadingItems" indeterminate :height="3" :color="'teal'" class="mb-0"></v-progress-linear>
        </v-flex>
        <v-flex xs12>
          <v-list light v-if="items.length === 0" two-line>
            <template>
            <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="title" style="margin-top: 25px;"> Não há notificações </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <v-list light v-else three-line :search="search">
            <v-divider></v-divider>
            <template v-for="(item, index) in items">
              <v-list-tile ripple :key="index">
                <v-list-tile-content>
                  <v-list-tile-title v-if="!$vuetify.breakpoint.smAndDown" class="title">{{ JSON.parse(item.data).title }} - <span class="date"> {{item.created_at | formatDateTime}} </span> </v-list-tile-title>
                  <v-list-tile-title v-else style="font-size: 17px; font-weight: bold;">{{ JSON.parse(item.data).title }} - <span class="date"> {{item.created_at | formatDateTime}} </span> </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{ JSON.parse(item.data).description }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-tooltip bottom>
                    <v-btn @click="redirect(item)" icon slot="activator" class="mx-0">
                      <v-icon color="primary">remove_red_eye</v-icon>
                    </v-btn>
                    <span>Detalhes</span>
                  </v-tooltip>
                </v-list-tile-action>

                <v-list-tile-action>
                  <v-tooltip bottom>
                    <v-btn icon slot="activator" class="mx-0">
                      <v-icon color="red" @click="markAsDone(item)">close</v-icon>
                    </v-btn>
                    <span>Marcar como visualizada</span>
                  </v-tooltip>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="'d' + index" v-if="index + 1 < items.length"></v-divider>
            </template>
          </v-list>
        </v-flex>
      </div>
    </v-layout>
  </div>
</template>

<style scoped>
  .date {
    color: gray;
    font-size: .7em;
    font-weight: normal;
  }
  .v-list__tile__sub-title {
    white-space: pre-wrap !important;
  }
  .v-list__tile__title {
    white-space: pre-wrap !important;
    height: 45px !important;
  }
</style>

<script>
  import notification from '../../mixin/notification.js'

  export default {
    mixins: [notification],
    data: function () {
      return {
        setNotificationInterval: '',
        setCheckEnabledInterval: '',
        notificationsEnabled: false,
        notificationLoading: false,
        notificationLoadingItems: false,
        filterItemMention: false,
        clearAllLoading: false,
        items: [],
        allItems: [],
        entity: 'notifications',
        search: '',
        url: ''
      }
    },
    mounted () {
      if (Notification.permission === 'granted') {
        if (this.subscription === null) {
          this.enableNotifications()
        }
      }
      // === POSTERIORMENTE ESTES DOIS INTERVALOS SERÃO SUBSTITUIDOS POR EVENTOS SOCKET ===
      // Após criar a página, fica sempre buscando o valor no localStorage para atribuir true ou false a variavel
      this.setCheckEnabledInterval = setInterval(() => {
        this.notificationsEnabled = localStorage.getItem('notificationsEnabled') === 'true'
      }, 1000)
      // De minuto em minuto busca as notificações não visualizadas do usuário no banco de dados
      // this.setNotificationInterval = setInterval(() => {
      //   this.$http.get(`api/get_user_notifications`).then((res) => {
      //     this.items = res.body['notifications']
      //     this.$emit('inviteBadge', res.body['invites'])
      //     this.$emit('notificationBadge', this.items.length)
      //   })
      // }, 60000)
    },
    methods: {
      notificationLoad () {
        this.notificationLoadingItems = true
        this.$http.get(`api/get_user_notifications`).then((res) => {
          console.log('retorno da requisição:', res)
          this.allItems = res.body
          this.filterMention()
          this.$emit('notificationBadge', res.body.length)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar as notificações.', color: 'error', dialog: true})
        }).finally(() => {
          this.notificationLoadingItems = false
        })
      },
      clearAll () {
        this.clearAllLoading = true
        this.$http.get(`api/clear_all_notifications/${this.filterItemMention}`).then(() => {
          this.items = []
          this.allItems = this.filterItemMention ? this.allItems.filter((item) => {
            return !JSON.parse(item.data).description.includes('mencionado')
          }) : []
          this.clearAllLoading = false
          this.$emit('notificationBadge', 0)
        })
      },
      // a function filterMention () faz um filtro das notificações que contem a menção do usuário no card de notificações;
      filterMention () {
        if (this.filterItemMention) {
          this.items = this.allItems.filter((item) => {
            return JSON.parse(item.data).description.includes('mencionado')
          })
        } else {
          this.items = this.allItems
        }
      },
      markAsDone (item) {
        const index = this.items.indexOf(item)
        this.$http.put(`api/notifications/${item.id}`, {done: true}).then(() => {
          this.items.splice(index, 1)
          this.$emit('notificationBadge', this.items.length)
        })
      },
      redirect (item) {
        const redirectData = JSON.parse(item.data)
        const index = this.items.indexOf(item)
        this.url = `${redirectData.name}|${redirectData.itemID}|${redirectData.company}`
        this.encrypt = btoa(this.url)
        this.$store.commit('loader/change_dialog', true)
        this.$http.put(`api/notifications/${item.id}`, {done: true}).then(() => {
          this.items.splice(index, 1)
          this.$emit('notificationBadge', this.items.length)
          this.$store.commit('loader/change_dialog', false)
          window.open(`/#/redirect/${this.encrypt}`)
        })
      },
      // Método para fazer o toggle nas notificações
      enableNotifications () {
        // Se o usuário não deu permissão para enviarmos notificações e tentar habilitá-las clicando no botão, exibe uma mensagem avisando ele.
        if (Notification.permission === 'denied') {
          this.$store.commit('snackbar/change_values', {
            text: "Pop-up's desativados. Altere as permissões do navegador para receber pop-up's.",
            color: 'error',
            dialog: true,
            timeout: 8000
          })
        } else if (this.notificationsEnabled) {
          // Se clicar e as notificações ja estiverem habilitadas, busca o registro de Subscription no banco e então desabilita
          this.findSubscription()
            .then(sub => {
              if (sub !== null) {
                this.subscription = sub
                this.disableSubscription()
              }
            })
        } else {
          // Se clicar e as notificações não estiverem habilitadas, cria subscription do usuário e habilita notificações.
          this.enableSubscription()
        }
      },
      afterDisableSubscription () {
        this.$store.commit('snackbar/change_values', {
          text: "Pop-up's desativados.",
          color: 'info',
          dialog: true,
          timeout: 5000
        })
      },
      afterEnableSubscription () {
        this.$store.commit('snackbar/change_values', {
          text: "Pop-up's ativados.",
          color: 'info',
          dialog: true,
          timeout: 5000
        })
      }
    },
    destroyed () {
      clearInterval(this.setNotificationInterval)
      clearInterval(this.setCheckEnabledInterval)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PCardNotification.vue